<template>
  <div id="footer" class="container-fluid">
    Copyright &copy; 2023 广西品为科技有限公司  桂ICP备16045432号-4 <el-image class="icon" :src="icon"></el-image>桂公网安备 11010802029085号
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      icon: require('@/assets/img/footer_icon.png')
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  padding: 17px 0;
  line-height: 14px;
  font-size: 12px;
  overflow: hidden;
  text-align: center;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  border-top: 1px solid #CED4DB;
}

.icon{
  margin-left:12px;
  margin-right:4px;
  position: relative;
  top: 4px;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue